import React, { FC } from 'react';
import { Row, Col } from 'antd';
import InputField from 'shared/components/InputField';
import styles from '../../activityDataEntry.module.scss';
import { Scope1DesiredData } from 'models/ActivityDataScope1DesiredData/scope1DesiredData.model';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { useFormikContext } from 'formik';
import { ScopeData } from 'models/ActivityDataEntryScopes/scopes.model';
import { convertToReadableText } from 'shared/utils/convertToUserReadable';
import { allowOnlyNumbers } from 'shared/utils/convertFormData';

interface ProcessSourcesFieldsProps {
  handleToolTipOpen: (fieldName: HelpDeskInputFieldEnum) => () => void;
  isEditView: boolean;
  handleMonthlyModalOpen: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string
  ) => () => void;
  handleSwitch: (
    source?: ScopeData,
    key?: string,
    selectedIndex?: string,
    selectedItemIndex?: number
  ) => () => void;
}

const ProcessSourcesFields: FC<ProcessSourcesFieldsProps> = ({
  handleToolTipOpen,
  isEditView,
  handleMonthlyModalOpen,
  handleSwitch,
}) => {
  const { values } = useFormikContext<Scope1DesiredData>();
  return (
    <Row gutter={[24, 40]} className={styles.processSourcesFormConatiner}>
      {values?.processSources?.map((source, index) => (
        <Col span={12} key={source?.fuelName}>
          <div className={styles.fieldContainer}>
            <Col span={values?.processSources?.[index].isYearly ? 16 : 9}>
              <InputField
                name={`processSources.${index}.fuelValue`}
                placeholderstring={source?.getPlaceholder?.() ?? ''}
                label={source?.getPlaceholder?.() ?? ''}
                info
                infoClick={handleToolTipOpen(
                  convertToReadableText(
                    source?.fuelName
                  ) as HelpDeskInputFieldEnum
                )}
                disabled={
                  !isEditView || !values?.processSources?.[index].isYearly
                }
                onKeyDown={allowOnlyNumbers}
                isNullable={true}
              />
            </Col>
            {!values?.processSources?.[index].isYearly && (
              <>
                <Col span={7}>
                  <p
                    className={styles.viewMonthlyText}
                    onClick={handleMonthlyModalOpen(
                      values?.processSources?.[index],
                      'processSources',
                      `processSources.${index}`
                    )}>
                    View Monthly data
                  </p>
                </Col>
                {isEditView && (
                  <span className={styles.pipeSeperator}> | </span>
                )}
              </>
            )}
            {isEditView && (
              <Col span={8}>
                <p
                  className={styles.monthlyText}
                  onClick={handleSwitch(
                    values?.processSources?.[index],
                    'processSources',
                    `processSources.${index}`
                  )}>
                  {values?.processSources?.[index].isYearly
                    ? 'Switch to monthly'
                    : 'Switch to annually'}
                </p>
              </Col>
            )}
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default ProcessSourcesFields;
